var settings = {
  debug: false,
  api: {
    protocol: 'https',
    host: 'api.worldwidewomen.co',
    port: 443,
    base: 'api/v1'
  }
};

settings.api.url = `${settings.api.protocol}://${settings.api.host}:${settings.api.port}/${settings.api.base}/`;

settings.facebook = {
  appId: '1661097430884599'
}

settings.GA = {
  code: 'UA-68083111-1'
}

settings.recaptcha = {
  key: '6Lf4SyETAAAAAMIficsFZQsggLe0ZLxx0ja1iGbm',
  secret: '6Lf4SyETAAAAAHrWSi3C3vRHUrcNHbApjUR3434L'
}

settings.raven = {
  "dsn": 'https://62916b94e72a4ed78d18b204221c6f91@sentry.io/102876',
  config: {}
}

settings.paypalenv = {
  env: 'production'
}

settings.paypalclient = {
  PAYPAL_CLIENT_ID_PRODUCTION: 'AWt5L6eaajWbHLohAGtcVy1oQU_ngZrttKV5-dmUCcWX-sY-Qfgt6qaAC5P7tRnq6Mhqg8aJCesgvbOY'
}


module.exports = settings



// WEBPACK FOOTER //
// ./src/settings/production.js